import reduce from "lodash/reduce";
import homeLogo from "@Components/molecules/cart/CartDeliveryMethod/images/home_delivery.png";
import mondialRelayLogo from "@Components/molecules/cart/CartDeliveryMethod/images/mondial_relay.png";
import { DeliveryMethod, DeliveryMethodName, ShippingOptions } from "@Types/addresses";
import { CheerzApiShippingOptions } from "@Types/api/shippingOption";
import CartContent from "@Types/cart";

const dateFormatOptions: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "short",
};

export const formatDate = (date: string, locale: string): string =>
  new Date(date).toLocaleDateString(locale, dateFormatOptions);

export const formatDates = (date1: string, date2: string, locale: string): string => {
  if (!date1) {
    return "";
  } else if (date1 === date2 || !date2) {
    return formatDate(date1, locale);
  } else {
    return `${formatDate(date1, locale)} - ${formatDate(date2, locale)}`;
  }
};

const deliveryLogos: { [key: string]: string } = {
  home: homeLogo,
  mondialRelay: mondialRelayLogo,
};

export const getDeliveryMethods = (cart: CartContent): DeliveryMethod[] => {
  const isAvailableDeliveryMethod = (
    key: string,
    value: ShippingOptions | undefined
  ): key is DeliveryMethodName =>
    value === undefined
      ? false
      : value.express.available || value.normal.available
      ? (key as unknown as boolean)
      : false;

  return reduce(
    cart.shippingOptions,
    (result: DeliveryMethod[], value, key) => {
      if (isAvailableDeliveryMethod(key, value)) {
        const selected = value
          ? [{ ...value.normal }, { ...value.express }].some((mode) => mode.selected)
          : false;
        result.push({ logo: deliveryLogos[key], name: key, selected, deliveryModes: value });
      }
      return result;
    },
    []
  );
};

export const getSelectedDeliveryMethod = (cart: CartContent): DeliveryMethod | undefined => {
  return getDeliveryMethods(cart).find((method) => method.selected === true);
};

export const convertFromShippingOptionsContentToApi = (
  shippingOptionsContent: ShippingOptions
): CheerzApiShippingOptions => {
  const shippingOptions: CheerzApiShippingOptions = {
    shipping_options: {
      normal: {
        selected: true,
      },
    },
  };
  if (shippingOptionsContent.express.selected) {
    shippingOptions.shipping_options = {
      express: {
        selected: shippingOptionsContent.express.selected,
      },
    };
  } else if (shippingOptionsContent.normal.selected) {
    shippingOptions.shipping_options = {
      normal: {
        selected: shippingOptionsContent.normal.selected,
      },
    };
  }
  return shippingOptions;
};

export const convertToShippingMethod = (method: DeliveryMethodName): string => {
  switch (method) {
    case "home":
      return "home_delivery";
    case "mondialRelay":
      return "mondial_relay";
    default:
      // Need bugsnag to manage error case
      return "";
  }
};
